import React from 'react';

export default function ({ name, errors, className }) {
  const error = _.get(errors, name);
  if (error) {
    return <span className={`help-block m-t-05 m-b-0 ${className}`}>{error}</span>;
  }
  return null;
}
